import KBlock from './KBlock.vue'
import KModal from './KModal.vue'
import KScreen from './KScreen.vue'
import KTextArea from './KTextArea.vue'

export {
  KBlock,
  KModal,
  KScreen,
  KTextArea
}
